import React from 'react';

export function highlightText(text, search) {
  if (!text || !search) {
    return text;
  }

  const parts = text.split(new RegExp(`(${search})`, 'gi'));
  return (
    <span>
      {parts.map((part, i) => (
        <span
          key={i}
          style={
            part.toLowerCase() === search?.toLowerCase()
              ? {fontWeight: '1000', background: 'yellow'}
              : {}
          }
        >
          {part}
        </span>
      ))}
    </span>
  );
}
